import React from "react"

const AllOrders = () => {
  return (
    <div className='all-orders'>
      <div className='header'>
        <i className='nc-icon nc-delivery-fast' />
        <div>All Orders</div>
      </div>
      <ul>
        <li className='mb-3'>
          Sylectus is the source of the data. If you want order details to
          change you will have to do it in Sylectus.
        </li>
        <li className='mb-3'>
          Select the terminal you are interested in:
          <div className='mt-2'>
            <button className='btn btn-primary btn-sm mr-2'>LRD NBB</button>
            <button className='btn btn-primary btn-sm mr-2'>CKV SBB</button>
            <button className='btn btn-primary btn-sm mr-2'>CKV NBB</button>
            <button className='btn btn-primary btn-sm mr-2'>DTW</button>
            <button className='btn btn-primary btn-sm mr-2'>DTW SB</button>
            <button className='btn btn-primary btn-sm mr-2'>Other</button>
            <button className='btn btn-primary btn-sm mr-2'>0 Miles</button>
            <button className='btn btn-primary btn-sm mr-2'>MX NB</button>
            <button className='btn btn-primary btn-sm mr-2'>MX SB</button>
          </div>
        </li>
        <li className='mb-3'>The table shows essential order details.</li>
        <li className='mb-3'>
          The <b>action</b> column allows you to complete CES business logic.
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-eye' />
            </button>
            <div>Build buses or ajust order details</div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-link' />
            </button>
            <div>See or adjust order reference data</div>
          </div>
          <div className='action'>
            <button
              className='btn btn-primary btn-xs mr-2'
              style={{ backgroundColor: "red" }}
            >
              <i className='fa fa-check' />
            </button>
            <div>
              Complete an order (generally done in the warehouse section)
            </div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-upload' />
            </button>
            <div>Push the order to CES Starboard</div>
          </div>
        </li>
        <li className='mb-3'>
          Every order is automatically populated in <b>Warehouse</b>. Once an
          order is assigned to a bus the order will be visible in <b>Buses</b>
        </li>
      </ul>
    </div>
  )
}

export default AllOrders
